import angular from "angular";

angular
    .module('Param', [])
    .service('Param', ['$http', function ($http) {

        function uri(key, path) {
            let link = '/control-panel/params';
            if (key) {
                link += '/' + key;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params)
        };

        this.update = function (key, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(key), params);
        };

        this.destroy = function (key) {
            return $http.post(uri(key), {'_method': 'DELETE'});
        };

    }]);

export default 'Param';


// WEBPACK FOOTER //
// ./resources/assets/modules/params-control/param.js